import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const MainFeatures = ({ features, cardsPerRow = 4, hasHeading }) => {
    // Split features into rows based on cardsPerRow
    const rows = [];
    for (let i = 0; i < features.length; i += cardsPerRow) {
        rows.push(features.slice(i, i + cardsPerRow));
    }

    return (
        <div style={{ backgroundColor: "#f8f9fa" }}>
            <Container className="mb-5 py-5">
                {hasHeading ? (
                    <>
                        <h2 className="fw-bold my-2">{hasHeading}</h2>
                        <div className="mx-auto mb-3" style={{
                    width: '60px',
                    height: '4px',
                    backgroundColor: '#3bc9f5',
                    borderRadius: '2px'
                }}></div>
                        <p className='fw-bold text-secondary mb-4'>We've worked with a variety of sectors, solving their complicated problems, assisting them in gaining more business, and eventually achieving their business objectives.</p>
                    </>) : 
                    (<>
                    <h2 className="fw-bold my-2">Main Features</h2>
                    <div className="mx-auto mb-5" style={{
                    width: '60px',
                    height: '4px',
                    backgroundColor: '#3bc9f5',
                    borderRadius: '2px'
                }}></div>
                    </>
                    
                )}

                

                {rows.map((row, rowIndex) => (
                    <Row key={rowIndex} className="mb-4">
                        {row.map((feature, index) => (
                            <Col key={index} md={12 / cardsPerRow} className="mb-3 mb-md-0">
                                <Card className="h-100 shadow-sm mainfeature-card" style={{ minHeight: '300px' }}>
                                    <Card.Body className="text-center p-4 d-flex flex-column">
                                        <div className="feature-icon mb-3 flex-grow-0">
                                            {feature.icon ? (
                                                <div className="icon-wrapper">
                                                    <img
                                                        src={feature.icon}
                                                        alt={feature.title}
                                                        className="feature-img"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center default-icon"
                                                    style={{ width: '120px', height: '120px', fontSize: '36px' }}>
                                                    {index + 1 + (rowIndex * cardsPerRow)}
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex-grow-1 d-flex flex-column justify-content-center">
                                            <Card.Title className="h5">{feature.title}</Card.Title>
                                            <Card.Text className="text-muted">
                                                {feature.description}
                                            </Card.Text>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ))}

                <style>{`
          .mainfeature-card {
            transition: all 0.3s ease;
            border: none;
            border-radius: 16px !important;
          }
          .mainfeature-card:hover {
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
          }
          .mainfeature-card .icon-wrapper {
            width: 90px;
            height: 90px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background-color: #f8f9fa;
            transition: all 0.3s ease;
          }
          .mainfeature-card:hover .icon-wrapper {
            background-color: rgb(4, 180, 228);
          }
          .feature-img {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }
          .default-icon {
            transition: all 0.3s ease;
          }
          .mainfeature-card:hover .default-icon {
            background-color: rgb(4, 180, 228) !important;
          }

          @media (max-width: 768px) {
            .mainfeature-card {
             min-height: 350px !important;
            }
            .mainfeature-card .icon-wrapper {
              width: 100px;
              height: 100px;
            }
            .feature-img {
              width: 50px;
              height: 50px;
            }
          }

          @media (max-width: 576px) {
            .mainfeature-card {
              min-height: 300px !important;
            }
            .mainfeature-card .icon-wrapper {
              width: 80px;
              height: 80px;
            }
            .feature-img {
              width: 40px;
              height: 40px;
            }
          }
        `}</style>
            </Container>
        </div>
    );
};

export default MainFeatures;